var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUndo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "redo",
    d: "M3.90472 7.99967L0.69043 4.66634L3.90472 1.33301M3.90472 14.6663H10.869C12.1477 14.6663 13.3741 14.1396 14.2783 13.2019C15.1825 12.2642 15.6904 10.9924 15.6904 9.66634C15.6904 8.34026 15.1825 7.06849 14.2783 6.13081C13.3741 5.19313 12.1477 4.66634 10.869 4.66634H1.76186",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUndo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/undo.624b8581.svg";
export { ForwardRef as ReactComponent };